// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { CashRegisterFragmentFragment } from '../../fragments/generated/cash-register.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type SearchCashRegisterQueryVariables = Types.Exact<{
  queryCashRegisterDTO: Types.QueryCashRegisterDtoInput;
}>;


export type SearchCashRegisterQueryResult = { __typename?: 'Query', searchCashRegister: Array<{ __typename?: 'CashRegisterDTO', id: number, invoiceBlocks: Array<string>, ownerCorporateDataId: number, description: string, address: string, port: string | null, localAddress: string | null, username: string | null, doubleCopy: boolean, cashRegisterType: { __typename?: 'CashRegisterTypeDTO', type: Types.CashRegisterTypeEnumDto | null, paperSize: Types.CashRegisterPaperSizeEnumDto | null, manufacturer: Types.CashRegisterManufacturerEnumDto | null } }> };

export const SearchCashRegisterGql = gql`
    query SearchCashRegister($queryCashRegisterDTO: QueryCashRegisterDTOInput!) {
  searchCashRegister(queryCashRegisterDTO: $queryCashRegisterDTO) {
    ...CashRegisterFragment
  }
}
    ${CashRegisterFragmentFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchCashRegisterInjectable extends Apollo.Query<SearchCashRegisterQueryResult, SearchCashRegisterQueryVariables> {
    override document = SearchCashRegisterGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */